import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Link, useLocation, useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../hooks/useRequest";
import Pagination from "../Pagination/Pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Table from "../Table/Table";
import { SearchInput2, SearchSubmitButton } from "../Form/Form";
import { addOneToDate } from "../../util/fn";
import { ArrowDown, ArrowUp } from "../../util/Svg";

const OBJ_TABLE = {
  "first name": "firstName",
  "last name": "lastName",
  email: "email",
  "phone number": "fullContact",
  country: "countryName",
  sport: "sportName",
  "registered on": "createdAt",
  status: "isActive",
};

const searchQueryHandler = (
  clubId = "",
  page,
  per_page,
  sortBy,
  order,
  isActive = "",
  firstName = "",
  lastName = "",
  email = "",
  country = "",
  sport = "",
  dateFrom = "1970-01-01",
  dateTo
) => {
  if (sortBy.length > 0) {
    if (sortBy == "registered on") {
      sortBy = "createdAt";
    } else if (sortBy == "first name") {
      sortBy = "firstName";
    } else if (sortBy == "last name") {
      sortBy = "lastName";
    } else if (sortBy == "phone number") {
      sortBy = "contact";
    } else if (sortBy == "country") {
      sortBy = "countryName";
    } else if (sortBy == "sport") {
      sortBy = "sportName";
    }
  } else {
    sortBy = "createdAt";
  }

  order = order.length > 0 ? order : "desc";
  dateFrom = dateFrom.length > 0 ? dateFrom : "1970-01-01";
  dateTo = dateTo ? addOneToDate(new Date(dateTo)) : addOneToDate(new Date());

  return `athletes/all?page=${page}&per_page=${per_page}&sortBy=${sortBy}&order=${order}&isActive=${isActive}&firstName=${firstName}&lastName=${lastName}&email=${email}&country=${country}&sport=${sport}&dateFrom=${dateFrom}&dateTo=${dateTo}&clubId=${clubId}`;
};

const ViewAll = () => {
  const [seekers, setSeekers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [perPage, setPerPage] = useState(0);
  const [currentSort, setCurrentSort] = useState({
    sortBy: "registered on",
    order: "desc",
  });

  const MySwal = withReactContent(Swal);
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const clubId = queryParams.get("clubId") ? queryParams.get("clubId") : "";

  const { records_per_page } = useSelector((state) => state.setting);
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    getValues,
    clearErrors,
    setError,
    clearError,
    watch,
    setValue,
    control,
  } = useForm();

  const { request, response } = useRequest();
  const { request: requestChangeStatus, response: responseChangeStatus } =
    useRequest();
  const { request: requestDelete, response: responseDelete } = useRequest();
  const { request: requestSendCreds, response: responseSendCreds } =
    useRequest();
  const { request: requestSport, response: responseSport } = useRequest();
  const { request: requestCountry, response: responseCountry } = useRequest();
  const { request: requestClub, response: responseClub } = useRequest();
  const [allSports, setAllSports] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [allClubs, setAllClubs] = useState([]);

  const [searchObj, setSearchObj] = useState({
    firstName: "",
    lastName: "",
    email: "",
    sports: "",
    country: "",
    dateFrom: "",
    dateTo: "",
  });
  const [isDisableSearch, setIsDisableSearch] = useState(true);

  const [isSearchToggleOpen, setIsSearchToggleOpen] = useState(false);

  const handleToggle = () => {
    const collapseElement = document.getElementById("collapseOne6");
    if (collapseElement) {
      collapseElement.classList.toggle("show");
    }
    setIsSearchToggleOpen(!isSearchToggleOpen);
  };

  useEffect(() => {
    if (clubId && allClubs.length > 0) {
      const club = allClubs.find((c) => c._id === clubId);
      if (club) {
        // bas id set karo, object nahi
        setValue("clubId", club._id);
          history.replace({
          pathname: location.pathname,
          search: ""
        });
      }
    }
  }, [clubId, allClubs, setValue]);

  useEffect(() => {
    if (records_per_page) {
      setPerPage(records_per_page);
      request(
        "GET",
        searchQueryHandler(
          clubId,
          1,
          records_per_page,
          currentSort.sortBy,
          currentSort.order
        )
      );
    }
  
    requestSport("GET", `master/all?page=1&isActive=${true}`);
    requestCountry("GET", `country/all?page=1&isActive=${true}`);
    requestClub("GET", `club/all?page=1&sortBy=organizationName&order=asc`);
    document.title = "Athletes- Calevalab";
  }, [records_per_page]);

  useEffect(() => {
    if (response) {
      setSeekers(response.data);
      setTotalDocuments((prev) =>
        response.totalDocuments !== undefined &&
        response.totalDocuments !== null
          ? response.totalDocuments
          : prev
      );
    }
  }, [response]);

  useEffect(() => {
    if (responseSport && responseSport.status) {
      setAllSports(responseSport.sports);
    }
  }, [responseSport]);

  useEffect(() => {
    if (responseClub) {
      if (responseClub?.status)
        setAllClubs(responseClub?.data?.length ? responseClub?.data : []);
    }
  }, [responseClub]);

  useEffect(() => {
    if (responseCountry && responseCountry.status) {
      setAllCountry(responseCountry.data);
    }
  }, [responseCountry]);

  useEffect(() => {
    if (responseChangeStatus) {
      const { id, status } = responseChangeStatus;

      const oldSeekers = [...seekers];
      const indexToChange = oldSeekers.findIndex((seeker) => seeker._id == id);
      oldSeekers[indexToChange].isActive = status;
      setSeekers(oldSeekers);
      toast.success("Athlete's status has been changed successfully.");
    }
  }, [responseChangeStatus]);

  useEffect(() => {
    if (responseDelete) {
      const { id } = responseDelete;
      let newSeeker = [...seekers];
      newSeeker = newSeeker.filter((seeker) => seeker._id != id);
      setSeekers(newSeeker);
      toast.success("Athlete has been deleted successfully.");
    }
  }, [responseDelete]);

  useEffect(() => {
    if (responseSendCreds) {
      toast.success("Login credentials sent successfully");
    }
  }, [responseSendCreds]);

  const fetchMoreData = ({ selected }) => {
    setSeekers([]);
    const {
      isActive,
      firstName,
      lastName,
      email,
      dateFrom,
      dateTo,
      country,
      sportName,
      clubId,
    } = getValues();

    setPage(selected + 1);
    request(
      "GET",
      searchQueryHandler(
        clubId,
        selected + 1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        firstName,
        lastName,
        email,
        country,
        sportName,
        dateFrom,
        dateTo
      )
    );
  };

  const deleteHandler = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You want to delete this athelete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        requestDelete("DELETE", "athletes", { id });
      } else if (result.isDismissed) {
      }
    });
  };

  const onSearchHandler = (data) => {
    const {
      isActive,
      firstName,
      lastName,
      email,
      dateFrom,
      dateTo,
      country,
      sportName,
      clubId,
    } = getValues();
    let error = 0;
    if (dateFrom && dateTo) {
      if (
        Moment(dateFrom).isAfter(dateTo) &&
        !Moment(dateFrom).isSame(dateTo, "day")
      ) {
        setError("dateTo", {
          type: "manual_other",
          message: "To Date cannot be smaller than From Date",
        });
        error = 1;
      }
    }
    if (new Date(dateFrom).getTime() > new Date().getTime()) {
      setError("dateFrom", { type: "manual" });
      error = 1;
    }
    if (new Date(dateTo).getTime() > new Date().getTime()) {
      setError("dateTo", { type: "manual" });
      error = 1;
    }
    if (error == 1) {
      return;
    }
    request(
      "GET",
      searchQueryHandler(
        clubId,
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        firstName,
        lastName,
        email,
        country,
        sportName,
        dateFrom,
        dateTo
      )
    );
    setPage(1);
  };

  const onResetHandler = (e) => {
    e.preventDefault();
    resetField("isActive");
    resetField("firstName");
    resetField("lastName");
    resetField("email");
    // resetField("sportName");
    // resetField("country");
    resetField("dateFrom");
    resetField("dateTo");
    setValue("sportName", "");
    setValue("country", "");
    setValue("clubId", "");

    setIsDisableSearch(true);
    request(
      "GET",
      searchQueryHandler(
        clubId,
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order
      )
    );
    setPage(1);
  };

  const perPageChangeHandler = (event) => {
    const {
      isActive,
      firstName,
      lastName,
      email,
      dateFrom,
      dateTo,
      country,
      sportName,
      clubId,
    } = getValues();
    request(
      "GET",
      searchQueryHandler(
        clubId,
        1,
        event.target.value,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        firstName,
        lastName,
        email,
        country,
        sportName,
        dateFrom,
        dateTo
      )
    );
    setPage(1);

    setPerPage(event.target.value);
  };

  const sortingHandler = (sortBy) => {
    const {
      isActive,
      firstName,
      lastName,
      email,
      dateFrom,
      dateTo,
      country,
      sportName,
      clubId,
    } = getValues();

    if (currentSort.sortBy == sortBy) {
      const newOrder = currentSort.order === "asc" ? "desc" : "asc";
      request(
        "GET",
        searchQueryHandler(
          clubId,
          page,
          perPage,
          sortBy,
          newOrder,
          isActive,
          firstName,
          lastName,
          email,
          country,
          sportName,
          dateTo
        )
      );
      setCurrentSort({ sortBy, order: newOrder });
    } else {
      request(
        "GET",
        searchQueryHandler(
          clubId,
          page,
          perPage,
          sortBy,
          "desc",
          isActive,
          firstName,
          lastName,
          email,
          country,
          sportName,
          dateFrom,
          dateTo
        )
      );
      setCurrentSort({ sortBy, order: "desc" });
    }
  };

  const changeStatusHandler = (id) => {
    const data = seekers.find((seeker) => seeker._id == id);
    const status = data.isActive == true ? false : true;
    MySwal.fire({
      title: "Are you sure?",
      text: "Want to change this status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        requestChangeStatus("PUT", "athletes/status", {
          id,
          status,
        });
      } else if (result.isDismissed) {
      }
    });
  };

  const sendCredentials = (id) => {
    requestSendCreds("POST", "athletes/send-credentials", { id });
  };

  const InputFields = [
    {
      label: "First Name",
      name: "firstName",
      required: false,
    },
    {
      label: "Last Name",
      name: "lastName",
      required: false,
    },
    {
      label: "Email",
      name: "email",
      required: false,
    },
    {
      isSelectInput: true,
      label: "Sports",
      name: "sportName",
      required: false,
      children: allSports &&
        allSports.length > 0 && [
          { value: "", label: "Select Sport" },
          ...(allSports && allSports.length > 0
            ? allSports.map((obj) => ({ value: obj._id, label: obj.name }))
            : []),
        ],
      control: control,
    },
    {
      isSelectInput: true,
      label: "Country",
      name: "country",
      required: false,
      children: allCountry &&
        allCountry.length > 0 && [
          { value: "", label: "Select Country" },
          ...(allCountry && allCountry.length > 0
            ? allCountry.map((obj) => ({ value: obj._id, label: obj.name }))
            : []),
        ],
      control: control,
    },
    {
      label: "Date From",
      name: "dateFrom",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "From Date cannot be greater than Current Date",
      },
    },
    {
      label: "Date To",
      name: "dateTo",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "To Date cannot be greater than Current Date",
      },
    },
    {
      isSelectInput: true,
      label: "Clubs",
      name: "clubId",
      required: false,
      children: [
        { value: "", label: "Select Club" },
        ...(allClubs && allClubs.length > 0
          ? allClubs.map((obj) => ({
              value: obj._id,
              label: obj.organizationName,
            }))
          : []),
      ],
      control: control,
    },
  ];

  const handleSearchObj = (name, value) => {
    if (name == "dateTo") {
      if (new Date(value).getTime() > new Date().getTime()) {
        setError("dateTo", { type: "manual", message: "manual" });
        return;
      }
      clearErrors(name);
    }
    if (name == "dateFrom") {
      if (new Date(value).getTime() > new Date().getTime()) {
        setError("dateFrom", { type: "manual", message: "manual" });
        return;
      }
      clearErrors(name);
    }
    let search = searchObj;
    search[name] = value;
    setSearchObj(search);
    if (search?.dateFrom && search?.dateTo) {
      if (
        Moment(search?.dateFrom).isAfter(search?.dateTo) &&
        !Moment(search?.dateFrom).isSame(search?.dateTo, "day")
      ) {
        setError("dateTo", {
          type: "manual_other",
          message: "To Date cannot be smaller than From Date",
        });
        return;
      }
    }

    if (
      search?.firstName ||
      search?.lastName ||
      search?.email ||
      search?.sportName ||
      search?.country ||
      search?.dateFrom ||
      search?.dateTo ||
      search?.clubId
    ) {
      setIsDisableSearch(false);
    } else {
      setIsDisableSearch(true);
    }
  };
  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb title="Athletes" links={[{ to: "/", name: "Dashboard" }]} />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="row">
            <div className="col-12">
              <div className="card card-custom card-stretch card-shadowless">
                <div className="card-header">
                  <div className="card-title"></div>
                  <div className="card-toolbar">
                    <a
                      className="btn btn-primary dropdown-toggle mr-2"
                      onClick={handleToggle}
                    >
                      Search {isSearchToggleOpen ? <ArrowUp /> : <ArrowDown />}
                    </a>
                    <Link to="/athletes/add" className="btn btn-primary">
                      Add New Athlete
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div
                    className="accordion accordion-solid accordion-toggle-plus"
                    id="accordionExample6"
                  >
                    <div
                      id="collapseOne6"
                      className="collapse "
                      data-parent="#accordionExample6"
                    >
                      <div>
                        <form
                          onSubmit={handleSubmit(onSearchHandler)}
                          className="kt-form kt-form--fit mb-0"
                        >
                          <div className="row mb-6">
                            {InputFields.map((inputMain, index) => (
                              <SearchInput2
                                key={index}
                                {...inputMain}
                                errors={errors}
                                register={register}
                                setValue={setValue}
                                handleSearchObj={handleSearchObj}
                              />
                            ))}
                          </div>
                          <SearchSubmitButton
                            handleSubmit={handleSubmit}
                            onSearchHandler={onSearchHandler}
                            onResetHandler={onResetHandler}
                            isDisableSearch={isDisableSearch}
                          />
                        </form>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div className="dataTables_wrapper">
                    <Table
                      currentSort={currentSort}
                      sortingHandler={sortingHandler}
                      mainData={seekers}
                      tableHeading={Object.keys(OBJ_TABLE)}
                      tableData={Object.values(OBJ_TABLE)}
                      links={[
                        {
                          isLink: false,
                          name: "Deactivate",
                          click: changeStatusHandler,
                          title: "Click To Activate",
                        },
                        {
                          isLink: false,
                          name: "Activate",
                          click: changeStatusHandler,
                          title: "Click To Deactivate",
                        },
                        {
                          isLink: true,
                          to: "/athletes/view",
                          name: "View",
                          extraData: true,
                        },
                        {
                          isLink: true,
                          to: "/athletes/edit",
                          name: "Edit",
                          extraData: true,
                        },
                        { isLink: false, name: "Delete", click: deleteHandler },
                        {
                          isLink: true,
                          to: "/athletes/change-password",
                          name: "ChangePassword",
                          extraData: true,
                          title: "Change Password",
                        },
                        {
                          isLink: false,
                          name: "SendCreds",
                          click: sendCredentials,
                          title: "Send Credentials",
                        },
                      ]}
                      onlyDate={{
                        createdAt: "date",
                        startDate: "dateTime",
                        endDate: "dateTime",
                      }}
                    />

                    {perPage !== 0 && (
                      <Pagination
                        page={page}
                        totalDocuments={totalDocuments}
                        getNewData={fetchMoreData}
                        perPage={perPage}
                        defaultPerPage={records_per_page}
                        perPageChangeHandler={perPageChangeHandler}
                        currentDocLength={seekers.length}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAll;
